import React, { useEffect, useState } from 'react';
function MexicoFlag() {
  return <svg viewBox="0 0 7 4" className="w-8 h-5 rounded-sm overflow-hidden shadow" aria-hidden="true" data-id="element-302">
      <rect width="7" height="4" fill="#006847" data-id="element-303" />
      <rect x="2.33" width="2.33" height="4" fill="#FFFFFF" data-id="element-304" />
      <rect x="4.67" width="2.33" height="4" fill="#CE1126" data-id="element-305" />
      <circle cx="3.5" cy="2" r="0.4" fill="#7B6225" opacity="0.85" data-id="element-306" />
    </svg>;
}
function USAFlag() {
  return <svg viewBox="0 0 7 4" className="w-8 h-5 rounded-sm overflow-hidden shadow" aria-hidden="true" data-id="element-307">
      <rect width="7" height="4" fill="#B22234" data-id="element-308" />
      {[1, 3, 5].map(y => <rect key={y} y={y * 4 / 13} width="7" height={4 / 13} fill="#FFFFFF" data-id="element-309" />)}
      {[7, 9, 11].map(y => <rect key={y} y={y * 4 / 13} width="7" height={4 / 13} fill="#FFFFFF" data-id="element-310" />)}
      <rect width="2.8" height={4 * 7 / 13} fill="#3C3B6E" data-id="element-311" />
      <g fill="#FFFFFF" data-id="element-312">
        {[...Array(5)].map((_, row) => [...Array(6)].map((_, col) => <circle key={`${row}-${col}`} cx={0.25 + col * 0.45} cy={0.2 + row * 0.4} r="0.08" data-id="element-313" />))}
      </g>
    </svg>;
}
interface LanguageGateProps {
  onSelect: (lang: 'es' | 'en') => void;
}
export function LanguageGate({
  onSelect
}: LanguageGateProps) {
  return <div className="fixed inset-0 z-[100] bg-[#3E2723] flex items-center justify-center p-6" data-id="element-314">
      <div className="absolute inset-0 opacity-10" data-id="element-315">
        <div className="absolute top-10 left-10 w-32 h-32 bg-[#C2410C] rounded-full blur-3xl" data-id="element-316"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-[#EC4899] rounded-full blur-3xl" data-id="element-317"></div>
        <div className="absolute top-1/2 left-1/2 w-48 h-48 bg-yellow-300 rounded-full blur-3xl" data-id="element-318"></div>
      </div>

      <div className="relative max-w-xl w-full text-center" data-id="element-319">
        <div className="inline-flex items-center gap-2 bg-yellow-400 text-[#3E2723] px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-6" data-id="element-320">
          Welcome · Bienvenido
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4" style={{
        fontFamily: 'DM Serif Display, serif'
      }} data-id="element-321">
          Authentic Mexico:
          <br className="hidden sm:block" data-id="element-322" />
          <span className="text-yellow-300" data-id="element-323"> The Resort Secrets</span>
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-10 max-w-md mx-auto" data-id="element-324">
          Choose your language to begin · Elige tu idioma para comenzar
        </p>

        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4" data-id="element-325">
          <button onClick={() => onSelect('es')} className="group flex items-center justify-center gap-3 bg-white hover:bg-yellow-300 text-[#3E2723] px-8 py-5 rounded-xl text-lg font-extrabold uppercase tracking-wide transition-all shadow-2xl border-4 border-transparent hover:border-yellow-300 hover:scale-105 min-w-[200px]" aria-label="Continue in Spanish" data-id="element-326">
            <MexicoFlag data-id="element-327" />
            <span data-id="element-328">Español</span>
          </button>

          <button onClick={() => onSelect('en')} className="group flex items-center justify-center gap-3 bg-[#C2410C] hover:bg-[#9A3412] text-white px-8 py-5 rounded-xl text-lg font-extrabold uppercase tracking-wide transition-all shadow-2xl border-4 border-transparent hover:border-yellow-300 hover:scale-105 min-w-[200px]" aria-label="Continue in English" data-id="element-329">
            <USAFlag data-id="element-330" />
            <span data-id="element-331">English</span>
          </button>
        </div>

        <p className="text-white/50 text-sm mt-8" data-id="element-332">
          You can change this later · Puedes cambiarlo después
        </p>
      </div>
    </div>;
}